import { dispatch } from "@shared/utils.events";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import type { BaseTrackingValues } from "./types";

type Props = BaseTrackingValues & {
  payload?: Record<string, unknown>;
};

export const useTrackElementViewed = ({
  target,
  location,
  payload
}: Props): {
  ref: (node?: Element | null | undefined) => void;
  isInView: boolean;
  elementViewed: () => void;
} => {
  const { inView, ref } = useInView({ threshold: 1, triggerOnce: true });

  const elementViewed = () => {
    dispatch("page element viewed", {
      target,
      ...(location && { location }),
      ...(payload && { ...payload })
    });
  };

  useEffect(() => {
    if (inView) {
      elementViewed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return {
    ref,
    isInView: inView,
    elementViewed
  };
};
